import React from "react";
import { AnalyticsTranslationHealthResponse } from "../../../api/v2/types";

interface AnalyticsTranslationHealthPanelProps {
  health: AnalyticsTranslationHealthResponse | null;
}

const AnalyticsTranslationHealthPanel = ({ health }: AnalyticsTranslationHealthPanelProps) => {
  if (!health) return <p className="text-sm text-muted-foreground">No translation health data.</p>;

  return (
    <div className="rounded border p-3">
      <p className="mb-2 text-sm font-semibold">Translation health</p>
      <div className="mb-2 grid grid-cols-2 gap-2 text-xs">
        <span>Bound files: {health.boundFiles}</span>
        <span>In scope: {health.jsonFilesInScope}</span>
        <span>Unbound JSON: {health.unboundJsonCount}</span>
        <span>Total missing keys: {health.totalMissingKeys}</span>
      </div>
      <div className="space-y-1">
        {health.groups.map((group) => (
          <div key={group.group} className="grid grid-cols-3 gap-2 rounded border p-2 text-xs">
            <span className="font-medium">{group.group}</span>
            <span>missing: {group.missingKeysCount}</span>
            <span>completion: {group.completionAvg.toFixed(1)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsTranslationHealthPanel;
